import axios from 'config/axiosPrivate';
import { GroupType } from 'types/groups';

export const getGroups = async (params: any): Promise<GroupType[]> => {
  const response = await axios.get('/groups/', { params });
  return response.data;
};

export const createGroup = async (params: any): Promise<GroupType> => {
  const response = await axios.post('/groups/', params);
  return response.data;
};

export const updateGroup = async (groupId: number, params: any): Promise<GroupType> => {
  const response = await axios.put(`/groups/${groupId}`, params);
  return response.data;
};

export const deleteGroup = async (groupId: number) => {
  const response = await axios.delete(`/groups/${groupId}`);
  return response.data;
};

export const duplicateGroup = async (groupId: number) => {
  const response = await axios.get(`/groups/${groupId}/duplicate`);
  return response.data;
};
